import { types, ISimpleType, IModelType } from 'mobx-state-tree'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { modelMap, modelNames, ModelName } from 'src/constants/models'
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader'
import { IModel } from './types'

export const Model: IModel = types
  .model('Model', {
    name: types.refinement(types.identifier, identifier =>
      modelNames.includes(identifier as ModelName)
    ) as ISimpleType<ModelName>
  })
  .extend(self => {
    let loading = true
    let model: THREE.BufferGeometry
    let promise: Promise<THREE.BufferGeometry>
    return {
      actions: {
        load() {
          if (promise === undefined && model === undefined) {
            console.log('LOAD MODEL')
            promise = new Promise<THREE.BufferGeometry>(resolve => {
              const modelPath = modelMap[self.name]
              if (modelPath.endsWith('stl')) {
                const loader = new STLLoader()
                loader.load(modelPath, modelData => {
                  loading = false
                  model = modelData
                  resolve(model)
                })
              } else {
                const loader = new GLTFLoader()
                const dracoLoader = new DRACOLoader()
                dracoLoader.setDecoderPath('/draco-gltf/')
                loader.setDRACOLoader(dracoLoader)
                loader.load(modelPath, modelData => {
                  loading = false

                  model =
                    ((modelData.scene.children[0] as THREE.Mesh)
                      .geometry as THREE.BufferGeometry) ||
                    ((modelData.scene.children[1] as THREE.Mesh).geometry as THREE.BufferGeometry)
                  resolve(model)
                })
              }
            })
          }
        }
      },
      views: {
        instance() {
          if (loading) {
            return promise
          } else {
            return model
          }
        }
      }
    }
  })
  .actions(self => ({
    afterCreate() {
      // console.log('AFTER CREATE LOADING MODEL', modelMap[self.name])
      self.load()
    },
    afterAttach() {
      // console.log('AFTERATTACH LOADING MODEL', modelMap[self.name])
      self.load()
    }
  }))
